
// src/connects/dashboard-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import config from '../config'
import moment from 'moment'
import reduce from 'lodash/reduce'
import find from 'lodash/find'

export function calcSummaryData(summary, opts = { diary: true, kpi: true, memo: true, like: true, comment: true }) {
  return {
    x_axis: summary.map((s)=> s.month.slice(0, 7)),
    posts_data: {
      diary: summary.map((s)=> opts.diary && s.diary || null),
      kpi:   summary.map((s)=> opts.kpi && s.kpi || null),
      memo:  summary.map((s)=> opts.memo && s.memo || null),
      avg:   summary.map((s)=> s.active_user > 0 ? Math.floor(((opts.diary && s.diary || 0) + (opts.kpi && s.kpi || 0) + (opts.memo && s.memo || 0)) / s.active_user * 10.0) / 10.0 : null)
    },
    replies_data: {
      like:    summary.map((s)=> opts.like && s.like || null),
      comment: summary.map((s)=> opts.comment && s.comment || null),
      avg:     summary.map((s)=> s.diary + s.kpi + s.memo > 0 ? Math.floor(((opts.like && s.like || 0) + (opts.comment && s.comment || 0)) / (s.diary + s.kpi + s.memo) * 10.0) / 10.0 : null)
    }
  }
}

export function calcMembersData(posts, replies, opts = { diary: true, kpi: true, memo: true, like: true, comment: true }) {
  let members = posts.map((m)=> m.user)
  members = members.concat(reduce(replies, (r, m)=> members.find((mm)=> mm.user_id == m.user.user_id) ? r : r.concat(m.user), []))

  let postHash  = reduce(posts, (r, post)=> { r[post.user.user_id] = post; return r }, {})
  let replyHash = reduce(replies, (r, reply)=> { r[reply.user.user_id] = reply; return r }, {})

  const _posts = members.map((m) => {
    let item = postHash[m.user_id]
    return {
      user: m,
      diary: opts.diary ? item && item.diary || 0 : null,
      kpi: opts.kpi ? item && item.kpi || 0 : null,
      memo: opts.memo ? item && item.memo || 0 : null,
    }
  })
  const _replies = members.map((m) => {
    let item = replyHash[m.user_id]
    return {
      user: m,
      like: opts.like ? item && item.like || 0 : null,
      comment: opts.comment ? item && item.comment || 0 : null,
    }
  })
  const avg_posts   = posts.length > 0 ? Math.floor(reduce(posts, (r, post)=> (opts.diary && post.diary || 0) + (opts.kpi && post.kpi || 0) + (opts.memo && post.memo || 0) + r, 0) / posts.length * 10.0) / 10.0 : 0
  const avg_replies = replies.length > 0 ? Math.floor(reduce(replies, (r, reply)=> (opts.like && reply.like || 0) + (opts.comment && reply.comment || 0) + r, 0) / replies.length * 10.0) / 10.0 : 0

  return {
    x_axis: members,
    posts_data: {
      diary: _posts.map((p)=> p.diary || 0),
      kpi:   _posts.map((p)=> p.kpi || 0),
      memo:  _posts.map((p)=> p.memo || 0),
    },
    replies_data: {
      like:    _replies.map((p)=> p.like || 0),
      comment: _replies.map((p)=> p.comment || 0),
    },
    avg_posts, avg_replies
  }
}

export const mapStateToProps = (state, ownProps)=> {
  return {
    isFetching: state.dashboard.isSummaryFetching || state.dashboard.isPostsFetching ||
                state.dashboard.isRepliesFetching || state.dashboard.isReceivesFetching,
    group: find(state.groups.items, (item)=> item.group_id == ownProps.params.group_id),
    summary: state.dashboard.summary,
    posts: state.dashboard.posts,
    replies: state.dashboard.replies,
    access_token: state.sessions.access_token,
    isShowTimeStamp: state.showTimeStamp?state.showTimeStamp.isEnable: false,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      const endDate = props.ui.startDate.clone().endOf('month')
      const lastYear = props.ui.startDate.clone().add(-5, 'month')
      dispatch(actions.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardPosts(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardReplies(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    exportUrl: (props)=> `${config.baseUrl}v3/export/monthly_summary.xlsx?group_id=${props.group.group_id}&start_date=${moment(props.ui.startDate).startOf('month').format('YYYY-MM-DD')}&access_token=${props.access_token}`,

    nextMonth: (props)=> {
      const startDate = props.ui.startDate.clone().add(1, 'months')
      const endDate = startDate.clone().endOf('month')
      const lastYear = props.ui.startDate.clone().add(-4, 'month')
      props.updateUI({ startDate })
      dispatch(actions.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardPosts(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardReplies(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    prevMonth: (props)=> {
      const startDate = props.ui.startDate.clone().add(-1, 'months')
      const endDate = startDate.clone().endOf('month')
      const lastYear = props.ui.startDate.clone().add(-6, 'month')
      props.updateUI({ startDate })
      dispatch(actions.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardPosts(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      dispatch(actions.fetchDashboardReplies(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    willUnmount: ()=> dispatch(actions.clearDashboardData()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    startDate: moment().startOf('month'),
    user: undefined,
    active: false,
  }}),
  lifecycle,
  translate(),
  trackPage('dashboard'),
)



// WEBPACK FOOTER //
// ./src/connects/dashboard-page.js